// Vendor libraries
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
export class TextEditModule {
}
TextEditModule.ɵfac = function TextEditModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TextEditModule)(); };
TextEditModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: TextEditModule });
TextEditModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, IconModule, FormsModule] });
